import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n\n  gap: 14px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useBooks } from "@/components/Books/Order";
import { AddToCartToast } from "@/components/Product/AddToCartToast";
import { calculateSaleRate } from "@/components/Product/CalculateSaleRate";
import Icon from "@/components/icon/Icon";
import { Cart, Sizes } from "@/components/icon/IconList";
import useRedirect from "@/hooks/useRedirect";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { productAddedToCart } from "@/lib/mixpanels/mixpanel";
import { numberFormatter } from "@/lib/utils/formatter";
import { BOOKS_ORDER, EBOOKS_ORDER, EBOOKS_UNIVERSITY_LANDING, LIBRARIES_INDEX_PAGE, SHOP_CART_PAGE } from "@/settings/constant";
import { ConfirmDialog } from "@bookips/solvook-ui-library";
import { useMutation } from "@tanstack/react-query";
import { Button } from "antd";
import { isAxiosError } from "axios";
import { useRouter } from "next/router";
import { useCallback, useMemo, useRef, useState } from "react";
import { getCurrentCartQuery, postBooksCartItem } from "src/api/booksCart";
import { isBooksProduct } from "src/api/booksProducts";
import useHandoutProductStore from "src/store/relatedProduct";
import { useModal } from "src/utils/overlay";
import styled, { useTheme } from "styled-components";
import { PriceInfo } from "../styles/ProductDetail.style";
import WarnBox from "./ProductDetail/WarnBox";
export var PurchaseStatus;
(function(PurchaseStatus) {
    PurchaseStatus["unknownLicense"] = "unknownLicense";
    PurchaseStatus["noLicense"] = "noLicense";
    PurchaseStatus["inActive"] = "inActive";
    PurchaseStatus["normal"] = "normal";
})(PurchaseStatus || (PurchaseStatus = {}));
export const getMillisecondsOfAddedModal = (product)=>1000 * (isBooksProduct(product) ? 5 : 2);
export const PriceSection = (param)=>{
    let { type ="default" , product  } = param;
    const router = useRouter();
    const theme = useTheme();
    const { isBooks  } = useBooks();
    const { isLoggedIn  } = useAuthStore();
    const { redirectToLogin  } = useRedirect();
    const timer = useRef();
    const [isShowModal, setIsShowModal] = useState(false);
    const originalPrice = isBooksProduct(product) ? numberFormatter(product.originPrice) : null;
    const productType = isBooksProduct(product) ? product.productType : product.source_type;
    const [addToCartCompleteModal, setAddToCartCompleteModal] = useState(false);
    const [isAlreadyPurchasedModal, { open: openAlreadyPurchasedModal , close: closeAlreadyPurchasedModal  }] = useModal("alreadyPurchased-modal");
    const [isAlreadyDialog, setIsAlreadyDialog] = useState(false);
    const { selectedPurchaseOption  } = useHandoutProductStore((state)=>({
            selectedPurchaseOption: state.selectedPurchaseOption
        }));
    const { purchaseStatus , statusMessage  } = useMemo(()=>{
        var _product_flags;
        let status = "normal";
        const isActive = (isBooksProduct(product) ? "active" : product.status) === "active";
        const canPurchase = isBooksProduct(product) ? false : product === null || product === void 0 ? void 0 : (_product_flags = product.flags) === null || _product_flags === void 0 ? void 0 : _product_flags.is_possible_purchase;
        if (!isActive) {
            status = "inActive";
        } else if (isBooksProduct(product)) {
            status = product.available ? "normal" : "noLicense";
        } else if (product.source_type === "handout" && !canPurchase) {
            status = isLoggedIn ? "noLicense" : "unknownLicense";
        }
        return {
            purchaseStatus: status,
            statusMessage: status === "unknownLicense" ? "구매제한이 있는 상품입니다.\n 로그인후 확인해주세요." : status !== "normal" ? "판매 중지된 상품입니다." : "".concat(productType === "ebook" ? "eBook " : productType === "aladinbook" ? "도서 " : "", "장바구니 담기")
        };
    }, [
        product,
        isLoggedIn,
        productType
    ]);
    const showCompletedAddingItemToCart = useCallback(()=>{
        clearTimeout(timer.current);
        setAddToCartCompleteModal(true);
        timer.current = setTimeout(()=>setAddToCartCompleteModal(false), getMillisecondsOfAddedModal(product));
    }, [
        product
    ]);
    const { refetch  } = getCurrentCartQuery({
        enabled: isLoggedIn,
        params: {
            cartType: isBooksProduct(product) ? product.productType : "separate"
        }
    });
    const { mutate: addItemToCart  } = useMutation({
        mutationFn: postBooksCartItem,
        onSuccess: async (data)=>{
            showCompletedAddingItemToCart();
            productAddedToCart({
                ...product,
                id: product.id,
                source_type: isBooksProduct(product) ? product.provider : product.source_type,
                source: isBooksProduct(product) ? null : product.source,
                purchaseOption: selectedPurchaseOption
            });
            refetch();
        },
        onError: (error)=>{
            if (isAxiosError(error)) {
                const { response: { status , data  }  } = error;
                if (status === 409 && data.message === "Already added") {
                    showCompletedAddingItemToCart();
                } else if (data.message === "Duplicate license") {
                    openAlreadyPurchasedModal();
                }
            }
        }
    });
    const licensePrice = useCallback(()=>{
        if (isBooksProduct(product)) {
            return {
                originalPrice: product.originPrice,
                price: product.price,
                id: product.id
            };
        } else {
            return {
                price: product.price,
                id: product.id
            } // Fallback if no variant is found
            ;
        }
    }, [
        product
    ]);
    const price = numberFormatter(licensePrice().price);
    const onCart = useCallback(async ()=>{
        if (!isLoggedIn) {
            redirectToLogin();
            return;
        }
        addItemToCart({
            cartType: isBooksProduct(product) ? product.productType : "separate",
            cartItems: [
                {
                    productId: "".concat(product.id)
                }
            ]
        });
    }, [
        isLoggedIn,
        redirectToLogin,
        product,
        showCompletedAddingItemToCart,
        addItemToCart,
        licensePrice
    ]);
    const handleClick = useCallback(()=>{
        clearTimeout(timer.current);
        setIsShowModal(true);
        onCart();
        timer.current = setTimeout(()=>setIsShowModal(false), getMillisecondsOfAddedModal(product) + 1000);
    }, [
        onCart,
        product
    ]);
    // 대학생 이북인지 체크합니다. 이북에서만 할인율을 보여주지 않습니다.
    const isUniversityHome = useMemo(()=>{
        if (router.pathname.includes(EBOOKS_UNIVERSITY_LANDING)) {
            return true;
        }
        return false;
    }, [
        router.pathname
    ]);
    return /*#__PURE__*/ _jsxs(PriceSectionLayout, {
        children: [
            /*#__PURE__*/ _jsxs(PriceInfo, {
                children: [
                    originalPrice && originalPrice !== price && /*#__PURE__*/ _jsxs("p", {
                        className: "original-price",
                        children: [
                            !isUniversityHome && /*#__PURE__*/ _jsx("span", {
                                className: "sale-rate",
                                children: calculateSaleRate(originalPrice, price)
                            }),
                            /*#__PURE__*/ _jsxs("span", {
                                className: "origin-price-text",
                                children: [
                                    originalPrice,
                                    "원"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: "price",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                children: "판매가 "
                            }),
                            price,
                            "원"
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        onClick: handleClick,
                        className: "ctCartBtn",
                        size: "large",
                        type: "primary",
                        block: true,
                        disabled: purchaseStatus !== "normal",
                        ghost: true,
                        children: statusMessage
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    position: "relative"
                },
                children: isShowModal && (isBooksProduct(product) ? /*#__PURE__*/ _jsx(AddToCartToast, {
                    addToCartCompleteModal: addToCartCompleteModal,
                    type: type,
                    link: isBooks ? BOOKS_ORDER : EBOOKS_ORDER,
                    content: /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                icon: Cart,
                                size: Sizes.medium,
                                color: theme.new.colors.white
                            }),
                            isBooks ? "도서" : "eBook",
                            " 장바구니에 담았어요"
                        ]
                    })
                }) : /*#__PURE__*/ _jsx(AddToCartToast, {
                    type: type,
                    content: /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                icon: Cart,
                                size: Sizes.medium,
                                color: theme.new.colors.white
                            }),
                            "장바구니에 담았어요"
                        ]
                    }),
                    link: SHOP_CART_PAGE,
                    addToCartCompleteModal: addToCartCompleteModal
                }))
            }),
            /*#__PURE__*/ _jsx(WarnBox, {
                productType: productType
            }),
            /*#__PURE__*/ _jsx(ConfirmDialog, {
                open: isAlreadyDialog,
                severity: "success",
                onClose: ()=>setIsAlreadyDialog(false),
                title: "이미 구매한 상품입니다",
                content: "마이쏠북의 자료 보관함을 통해 상품을 확인할 수 있습니다.",
                okText: "자료 보관함 가기",
                onOk: ()=>router.push(LIBRARIES_INDEX_PAGE),
                cancelText: "닫기"
            })
        ]
    });
};
const PriceSectionLayout = styled.div.withConfig({
    componentId: "sc-5b09f161-0"
})(_templateObject());
